// src/pages/AyurvedSpa.jsx
import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

// Import Images (Update paths to match actual files)
import spaImage from '../assets/Spa/DSC_0731.JPG';
import steamBath1 from '../assets/Spa/day_d1.jpg';
import steamBath2 from '../assets/Spa/DSC_0391.JPG';
import steamBath3 from '../assets/Spa/66286624.jpg';

import shirodhara1 from '../assets/Spa/7.jpeg';
import shirodhara2 from '../assets/Spa/Ayurvedic-Spa-and-Wellness-Gallery4-1300x700-1-ezgif.com-webp-to-jpg-converter.jpg';
import shirodhara3 from '../assets/Spa/csm_Ayurveda_shutterstock_319365299_C_a2d2853096.webp';

import bodyCare1 from '../assets/Spa/aromatherapy-massage-scaled-e1582251557268.jpg';
import bodyCare2 from '../assets/Spa/images.jpeg';
import bodyCare3 from '../assets/Spa/5.jpg';
import bodyCare4 from '../assets/Spa/Untitled+design+(20).png';

import footCare1 from '../assets/Spa/Poor-Circulation-Legs.jpg';
import footCare2 from '../assets/Spa/three-types-of-massage-for-your-feet.jpg';
import footCare3 from '../assets/Spa/foot-reflexology-session-header-800x728.avif';
import footCare4 from '../assets/Spa/11.webp';

import shiroCare1 from '../assets/Spa/Shiro-Abyanga-Head-massages.webp';
import shiroCare2 from '../assets/Spa/massage-desktop-large.jpg';

import skinCare1 from '../assets/Spa/jasmin-package-640x360.jpg';
import skinCare2 from '../assets/Spa/12.webp';

import comboPackage1 from '../assets/Spa/images.jpeg';
import comboPackage2 from '../assets/Spa/DSC_0362.JPG';

const AyurvedSpa = () => {
    useEffect(() => {
        // Dynamically load the Elfsight script
        const script = document.createElement('script');
        script.src = "https://static.elfsight.com/platform/platform.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);
    return (
        <>
            {/* Hero Section */}
            <section
                className="position-relative d-flex align-items-center justify-content-center text-center text-white"
                style={{
                    backgroundImage: `url(${spaImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '50vh', // Adjusted for mobile
                    minHeight: '300px', // Minimum height for very small screens
                    width: '100%',
                }}
            >
                {/* Overlay */}
                <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"></div>

                {/* Content Centered on Image */}
                <div className="position-relative z-index-1 px-3">
                    <h1 className="display-4 display-md-3 fw-bold">Cinnamon Mantra Ayurved Spa & Wellness</h1>
                    <p className="fs-6 fs-md-5 w-75 mx-auto">
                        Experience the ultimate relaxation with our Ayurvedic spa treatments.
                        Rejuvenate your mind, body, and soul with ancient healing techniques
                        designed to restore balance and well-being.
                    </p>
                </div>
            </section>

            {/* Steam Bath Benefits Section */}
            <section className="container my-5">
                <div className="row">
                    {/* Left Side - Images */}
                    <div className="col-md-6 order-2 order-md-1 mt-4 mt-md-0">
                        <div className="d-flex flex-column">
                            <img src={steamBath1} alt="Steam Bath 1" className="img-fluid rounded mb-3" />
                            <div className="d-flex">
                                <img src={steamBath2} alt="Steam Bath 2" className="img-fluid rounded me-2" style={{ width: '48%' }} />
                                <img src={steamBath3} alt="Steam Bath 3" className="img-fluid rounded" style={{ width: '48%' }} />
                            </div>
                        </div>
                    </div>

                    {/* Right Side - Steam Bath Benefits & Massage List */}
                    <div className="col-md-6 order-1 order-md-2">
                        <h2 className="fw-bold text-uppercase" style={{ color: '#819371' }}>Steam Bath Benefits</h2>
                        <ul className="list-unstyled">
                            <li className="mb-3">
                                <strong className="text-danger">✔ Removes Toxins:</strong> Steam baths help detoxify your body by opening up pores and flushing out harmful toxins.
                            </li>
                            <li className="mb-3">
                                <strong className="text-danger">✔ Promotes Weight Loss:</strong> Increases body temperature, boosting metabolism and aiding in calorie burn.
                            </li>
                            <li className="mb-3">
                                <strong className="text-danger">✔ Relieves Respiratory Ailments:</strong> Helps clear sinuses and relieves asthma, bronchitis, sinusitis, and allergies.
                            </li>
                            <li className="mb-3">
                                <strong className="text-danger">✔ Relieves Muscle Tension and Stiff Joints:</strong> Reduces soreness and enhances flexibility.
                            </li>
                            <li className="mb-3">
                                <strong className="text-danger">✔ Reduces Stress:</strong> The warmth of steam relaxes muscles and promotes mental well-being.
                            </li>
                            <li className="mb-3">
                                <strong className="text-danger">✔ Boosts the Immune System:</strong> Stimulates white blood cell production, helping your body fight infections.
                            </li>
                            <li className="mb-3">
                                <strong className="text-danger">✔ Improves Blood Circulation & Reduces Cellulite:</strong> Enhances oxygen flow in the body and smooths the skin.
                            </li>
                        </ul>

                        {/* Massage Pricing & List */}
                        <div className="p-4 bg-light shadow-lg rounded mt-4">
                            <h4 className="text-center fw-bold bg-dark text-light py-2 rounded">
                                120 min
                            </h4>
                            <ul className="list-unstyled mt-3">
                                <li className="fw-bold">Head Massage <span className="text-muted">| Kopfmassage</span></li>
                                <li className="fw-bold">Face Massage <span className="text-muted">| Gesichtsmassage</span></li>
                                <li className="fw-bold">Neck Massage <span className="text-muted">| Nackenmassage</span></li>
                                <li className="fw-bold">Shoulder Massage <span className="text-muted">| Schultermassage</span></li>
                                <li className="fw-bold">Body Massage <span className="text-muted">| Körpermassage</span></li>
                                <li className="fw-bold">Back Massage <span className="text-muted">| Antwort</span></li>
                                <li className="fw-bold">Foot Massage <span className="text-muted">| Fußmassage</span></li>
                                <li className="fw-bold">Steam Bath <span className="text-muted">| Dampfbad</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            {/* Shirodhara Benefits Section */}
            <section className="container my-5">
                <div className="row">
                    {/* Left Side - Shirodhara Benefits */}
                    <div className="col-md-6">
                        <h2 className="fw-bold text-uppercase" style={{ color: '#819371' }}>Shirodhara Benefits</h2>
                        <ul className="list-unstyled">
                            <li className="mb-3">
                                <strong className="text-danger">✔ Relaxes Mind:</strong> The continuous flow of warm oil on the forehead calms the nervous system and promotes relaxation.
                            </li>
                            <li className="mb-3">
                                <strong className="text-danger">✔ Promotes Better Sleep:</strong> Helps combat insomnia and improves overall sleep quality.
                            </li>
                            <li className="mb-3">
                                <strong className="text-danger">✔ Improves Concentration:</strong> Enhances mental clarity and cognitive functions.
                            </li>
                            <li className="mb-3">
                                <strong className="text-danger">✔ Nourishes Hair & Scalp:</strong> Strengthens hair roots, prevents dryness, and promotes healthy hair growth.
                            </li>
                            <li className="mb-3">
                                <strong className="text-danger">✔ Reduces Anxiety and Fear:</strong> Helps in calming emotions and reducing anxiety levels.
                            </li>
                            <li className="mb-3">
                                <strong className="text-danger">✔ Reduces Memory Problems:</strong> Supports brain health and prevents cognitive decline.
                            </li>
                        </ul>

                        {/* Massage Pricing & List Below the Benefits */}
                        <div className="p-4 bg-light shadow-lg rounded mt-4">
                            <h4 className="text-center fw-bold bg-dark text-light py-2 rounded">
                                120 min
                            </h4>
                            <ul className="list-unstyled mt-3">
                                <li className="fw-bold">Head Massage <span className="text-muted">| Kopfmassage</span></li>
                                <li className="fw-bold">Face Massage <span className="text-muted">| Gesichtsmassage</span></li>
                                <li className="fw-bold">Neck Massage <span className="text-muted">| Nackenmassage</span></li>
                                <li className="fw-bold">Shoulder Massage <span className="text-muted">| Schultermassage</span></li>
                                <li className="fw-bold">Body Massage <span className="text-muted">| Körpermassage</span></li>
                                <li className="fw-bold">Back Massage <span className="text-muted">| Antwort</span></li>
                                <li className="fw-bold">Foot Massage <span className="text-muted">| Fußmassage</span></li>
                                <li className="fw-bold">Shirodhara <span className="text-muted">| Dampfbad</span></li>
                            </ul>
                        </div>
                    </div>

                    {/* Right Side - Shirodhara Images */}
                    <div className="col-md-6 mt-4 mt-md-0">
                        <div className="d-flex flex-column">
                            <img src={shirodhara1} alt="Shirodhara 1" className="img-fluid rounded mb-3" />
                            <div className="d-flex">
                                <img src={shirodhara2} alt="Shirodhara 2" className="img-fluid rounded me-2" style={{ width: '48%' }} />
                                <img src={shirodhara3} alt="Shirodhara 3" className="img-fluid rounded" style={{ width: '48%' }} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Body Care Section */}
            <section className="container my-5">
                <h2 className="text-center fw-bold mb-4 display-4" style={{ color: '#819371' }}>Body Care</h2>
                <div className="row justify-content-center">
                    {/* Aroma Therapy 60 min */}
                    <div className="col-lg-3 col-md-6 mb-4">
                        <div className="card border-0 shadow-lg overflow-hidden rounded-4 hover-effect" style={{ height: '100%' }}>
                            <div className="position-relative">
                                <img src={bodyCare1} alt="Aroma Therapy Massage" className="card-img-top"
                                    style={{ height: '250px', objectFit: 'cover' }} />
                                <div className="position-absolute top-0 start-0 bg-dark text-light px-3 py-2 rounded-bottom">
                                    60 min
                                </div>
                            </div>
                            <div className="card-body text-center">
                                <h4 className="fw-bold">Aroma Therapy Body Massage</h4>
                                <p className="text-muted">Soft</p>
                                <p className="small">
                                    Soft and Smooth Relaxing Massage for the Body and Foot.
                                    Medium Pressure Muscles Relaxing Massage.
                                    Deeper Tissues and Muscle Relaxation Therapy.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Aroma Therapy 90 min */}
                    <div className="col-lg-3 col-md-6 mb-4">
                        <div className="card border-0 shadow-lg overflow-hidden rounded-4 hover-effect" style={{ height: '100%' }}>
                            <div className="position-relative">
                                <img src={bodyCare2} alt="Aroma Therapy Massage" className="card-img-top"
                                    style={{ height: '250px', objectFit: 'cover' }} />
                                <div className="position-absolute top-0 start-0 bg-dark text-light px-3 py-2 rounded-bottom">
                                    90 min
                                </div>
                            </div>
                            <div className="card-body text-center">
                                <h4 className="fw-bold">Aroma Therapy Body Massage</h4>
                                <p className="text-muted">Medium</p>
                                <p className="small">
                                    Soft and Smooth Relaxing Massage for the Body and Foot.
                                    Medium Pressure Muscles Relaxing Massage.
                                    Deeper Tissues and Muscle Relaxation Therapy.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Aroma Therapy 120 min */}
                    <div className="col-lg-3 col-md-6 mb-4">
                        <div className="card border-0 shadow-lg overflow-hidden rounded-4 hover-effect" style={{ height: '100%' }}>
                            <div className="position-relative">
                                <img src={bodyCare3} alt="Aroma Therapy Massage" className="card-img-top"
                                    style={{ height: '250px', objectFit: 'cover' }} />
                                <div className="position-absolute top-0 start-0 bg-dark text-light px-3 py-2 rounded-bottom">
                                    120 min
                                </div>
                            </div>
                            <div className="card-body text-center">
                                <h4 className="fw-bold">Aroma Therapy Body Massage</h4>
                                <p className="text-muted">Deeper</p>
                                <p className="small">
                                    Soft and Smooth Relaxing Massage for the Body and Foot.
                                    Medium Pressure Muscles Relaxing Massage.
                                    Deeper Tissues and Muscle Relaxation Therapy.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Back Massage */}
                    <div className="col-lg-3 col-md-6 mb-4">
                        <div className="card border-0 shadow-lg overflow-hidden rounded-4 hover-effect" style={{ height: '100%' }}>
                            <div className="position-relative">
                                <img src={bodyCare4} alt="Back Massage" className="card-img-top"
                                    style={{ height: '250px', objectFit: 'cover' }} />
                                <div className="position-absolute top-0 start-0 bg-dark text-light px-3 py-2 rounded-bottom">
                                    30 min
                                </div>
                            </div>
                            <div className="card-body text-center">
                                <h4 className="fw-bold">Back Massage</h4>
                                <p className="text-muted">Stress Relief Therapy</p>
                                <p className="small">
                                    A relaxing massage for the back of the body, including the
                                    neck, shoulders, and lower back to relieve tension and stress.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Foot Care Section */}
            <section className="container my-5">
                <h2 className="text-center fw-bold mb-4 display-4" style={{ color: '#819371' }}>Foot Care</h2>
                <div className="row justify-content-center">
                    {/* Jet Lag Massage */}
                    <div className="col-lg-3 col-md-6 mb-4">
                        <div className="card border-0 shadow-lg overflow-hidden rounded-4" style={{ height: '100%' }}>
                            <div className="position-relative">
                                <img src={footCare1} alt="Jet Lag Massage" className="card-img-top"
                                    style={{ height: '250px', objectFit: 'cover' }} />
                                <div className="position-absolute top-0 start-0 bg-dark text-light px-3 py-2 rounded-bottom">
                                    20 min
                                </div>
                            </div>
                            <div className="card-body text-center">
                                <h4 className="fw-bold">Jet Leg</h4>
                                <p className="text-muted">Leg Pain Relief Therapy</p>
                                <p className="small">
                                    Quick pain relief leg massage up to the knee joint to reduce swelling,
                                    improve circulation, and help with post-travel fatigue.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Happy Feet Massage */}
                    <div className="col-lg-3 col-md-6 mb-4">
                        <div className="card border-0 shadow-lg overflow-hidden rounded-4" style={{ height: '100%' }}>
                            <div className="position-relative">
                                <img src={footCare2} alt="Happy Feet Massage" className="card-img-top"
                                    style={{ height: '250px', objectFit: 'cover' }} />
                                <div className="position-absolute top-0 start-0 bg-dark text-light px-3 py-2 rounded-bottom">
                                    20 min
                                </div>
                            </div>
                            <div className="card-body text-center">
                                <h4 className="fw-bold">Happy Feet</h4>
                                <p className="text-muted">Foot Pressure Point Massage</p>
                                <p className="small">
                                    A specialized massage focusing only on the feet, using stimulating
                                    pressure points to relieve stress and enhance blood circulation.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Reflexology Foot Massage */}
                    <div className="col-lg-3 col-md-6 mb-4">
                        <div className="card border-0 shadow-lg overflow-hidden rounded-4" style={{ height: '100%' }}>
                            <div className="position-relative">
                                <img src={footCare3} alt="Reflexology Foot Massage" className="card-img-top"
                                    style={{ height: '250px', objectFit: 'cover' }} />
                                <div className="position-absolute top-0 start-0 bg-dark text-light px-3 py-2 rounded-bottom">
                                    40 min
                                </div>
                            </div>
                            <div className="card-body text-center">
                                <h4 className="fw-bold">Reflexology Foot Massage</h4>
                                <p className="text-muted">Deep Healing Therapy</p>
                                <p className="small">
                                    A deep cure massage from feet to knees, stimulating reflexology points.
                                    The session begins with a detoxifying foot wash for a holistic experience.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Foot Polish (Scrub and Pack) */}
                    <div className="col-lg-3 col-md-6 mb-4">
                        <div className="card border-0 shadow-lg overflow-hidden rounded-4" style={{ height: '100%' }}>
                            <div className="position-relative">
                                <img src={footCare4} alt="Foot Polish (Scrub and Pack)" className="card-img-top"
                                    style={{ height: '250px', objectFit: 'cover' }} />
                                <div className="position-absolute top-0 start-0 bg-dark text-light px-3 py-2 rounded-bottom">
                                    60 min
                                </div>
                            </div>
                            <div className="card-body text-center">
                                <h4 className="fw-bold">Foot Polish (Scrub and Pack)</h4>
                                <p className="text-muted">Exfoliation & Nourishment</p>
                                <p className="small">
                                    A luxurious foot treatment using natural scrubs and masks to eliminate
                                    dry and dead skin, leaving feet soft, smooth, and rejuvenated.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Shiro (Head) Care Section */}
            <section className="container my-5">
                <h2 className="text-center fw-bold mb-4 display-4" style={{ color: '#819371' }}>Shiro (Head) Care</h2>
                <div className="row justify-content-center">
                    {/* Head Massage */}
                    <div className="col-lg-4 col-md-6 mb-4">
                        <div className="card border-0 shadow-lg overflow-hidden rounded-4" style={{ height: '100%' }}>
                            <div className="position-relative">
                                <img src={shiroCare1} alt="Head Massage" className="card-img-top"
                                    style={{ height: '250px', objectFit: 'cover' }} />
                                <div className="position-absolute top-0 start-0 bg-dark text-light px-3 py-2 rounded-bottom">
                                    20 min
                                </div>
                            </div>
                            <div className="card-body text-center">
                                <h4 className="fw-bold">Head Massage</h4>
                                <p className="small">
                                    A soothing massage focused on the head, reducing stress, enhancing
                                    circulation, and promoting relaxation.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Head & Shoulder Massage */}
                    <div className="col-lg-4 col-md-6 mb-4">
                        <div className="card border-0 shadow-lg overflow-hidden rounded-4" style={{ height: '100%' }}>
                            <div className="position-relative">
                                <img src={shiroCare2} alt="Head and Shoulder Massage" className="card-img-top"
                                    style={{ height: '250px', objectFit: 'cover' }} />
                                <div className="position-absolute top-0 start-0 bg-dark text-light px-3 py-2 rounded-bottom">
                                    30 min
                                </div>
                            </div>
                            <div className="card-body text-center">
                                <h4 className="fw-bold">Head & Shoulder Massage</h4>
                                <p className="small">
                                    A combined therapy targeting the head and shoulders,
                                    easing tension, reducing headaches, and improving posture.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Skin Care Section */}
            <section className="container my-5">
                <h2 className="text-center fw-bold mb-4 display-4" style={{ color: '#819371' }}>Skin Care</h2>
                <div className="row justify-content-center">
                    {/* Herbal Body Scrub */}
                    <div className="col-lg-4 col-md-6 mb-4">
                        <div className="card border-0 shadow-lg overflow-hidden rounded-4" style={{ height: '100%' }}>
                            <div className="position-relative">
                                <img src={skinCare1} alt="Herbal Body Scrub" className="card-img-top"
                                    style={{ height: '250px', objectFit: 'cover' }} />
                                <div className="position-absolute top-0 start-0 bg-dark text-light px-3 py-2 rounded-bottom">
                                    30 min
                                </div>
                            </div>
                            <div className="card-body text-center">
                                <h4 className="fw-bold">Herbal Body Scrub</h4>
                                <p className="small">
                                    A medicinal blend used to remove dead skin cells, detoxify,
                                    and rejuvenate the skin, leaving it soft and radiant.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Body Shine (Scrub and Pack) */}
                    <div className="col-lg-4 col-md-6 mb-4">
                        <div className="card border-0 shadow-lg overflow-hidden rounded-4" style={{ height: '100%' }}>
                            <div className="position-relative">
                                <img src={skinCare2} alt="Body Shine Scrub & Pack" className="card-img-top"
                                    style={{ height: '250px', objectFit: 'cover' }} />
                                <div className="position-absolute top-0 start-0 bg-dark text-light px-3 py-2 rounded-bottom">
                                    60 min
                                </div>
                            </div>
                            <div className="card-body text-center">
                                <h4 className="fw-bold">Body Shine (Scrub and Pack)</h4>
                                <p className="small">
                                    A premium treatment that includes a medicated body mask
                                    to nourish and smooth the skin, enhancing its glow.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Combo Packages Section */}
            <section className="container my-5">
                <h2 className="text-center fw-bold mb-4 display-4" style={{ color: '#819371' }}>Combo Packages</h2>
                <div className="row justify-content-center">
                    {/* Body Massage with Body Scrub */}
                    <div className="col-lg-4 col-md-6 mb-4">
                        <div className="card border-0 shadow-lg overflow-hidden rounded-4" style={{ height: '100%' }}>
                            <div className="position-relative">
                                <img src={comboPackage1} alt="Body Massage with Scrub" className="card-img-top"
                                    style={{ height: '250px', objectFit: 'cover' }} />
                                <div className="position-absolute top-0 start-0 bg-dark text-light px-3 py-2 rounded-bottom">
                                    90 min
                                </div>
                            </div>
                            <div className="card-body text-center">
                                <h4 className="fw-bold">Body Massage with Body Scrub</h4>
                                <p className="small">
                                    A complete rejuvenation experience that combines a relaxing
                                    full-body massage with a refreshing exfoliating scrub.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Body Massage with Body Shine */}
                    <div className="col-lg-4 col-md-6 mb-4">
                        <div className="card border-0 shadow-lg overflow-hidden rounded-4" style={{ height: '100%' }}>
                            <div className="position-relative">
                                <img src={comboPackage2} alt="Body Massage with Body Shine" className="card-img-top"
                                    style={{ height: '250px', objectFit: 'cover' }} />
                                <div className="position-absolute top-0 start-0 bg-dark text-light px-3 py-2 rounded-bottom">
                                    120 min
                                </div>
                            </div>
                            <div className="card-body text-center">
                                <h4 className="fw-bold">Body Massage with Body Shine Treatment</h4>
                                <p className="small">
                                    A luxurious package that includes a full-body massage followed
                                    by a body shine treatment, leaving your skin radiant and refreshed.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Google Reviews Section */}
                <section className="container my-5">
                    <h2 className="text-center fw-bold mb-4 display-4" style={{ color: '#819371' }}>Customer Reviews</h2>
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            {/* Elfsight Google Reviews Widget */}
                            <div className="elfsight-app-8ce8f194-068f-452a-b477-5b8e95516a25" data-elfsight-app-lazy></div>
                        </div>
                    </div>
                </section>
                {/* Location Section */}
                <div className="text-center" style={{ marginTop: '40px' }}>
                    <h2 className="fw-bold" style={{ color: '#819371', fontSize: '3em' }}>Cinnamon Mantra Ayurveda Spa</h2>
                    <iframe
                        title="Location Map"
                        src="https://maps.google.com/maps?q=6.5165,79.9783&t=&z=15&ie=UTF8&iwloc=&output=embed"
                        width="100%"
                        height="400"
                        frameBorder="0"
                        style={{ borderRadius: '10px', border: '0' }}
                        allowFullScreen
                    ></iframe>
                </div>







            </section>
        </>
    );
};

export default AyurvedSpa;